// base
import { useContext } from 'react';

// contexts
import { AlarmContext } from 'contexts';

export const useAlarm = () => {
  const context = useContext(AlarmContext);

  if (!context) {
    throw new Error('useAlarm must be used within a AlarmProvider');
  }

  return {
    ...context
  };
};
